<div class="calendar-month">
  <app-calendar-header [focusDate]="focusDate" (jumpToDate)="jumpToDate($event)" (prev)="prevMonth()"
    (next)="nextMonth()" [loading]="loading"></app-calendar-header>

  <app-calendar-grid [events]="events" [focusDate]="focusDate"
    (dayWithEventsClicked)="openListEventsDialog($event)"></app-calendar-grid>
</div>
